import { RouteConfig } from 'vue-router';
import MswOrders  from './msw-orders.vue';
import OrderReciept  from './components/order-reciept.vue';

export const mswOrdersPage: RouteConfig = {
  path: 'orderhistory',
  component: MswOrders,
};
export const mswOrderReciept: RouteConfig = {
  path: 'orderreceipt',
  component: OrderReciept,
};

export function getDefaultParams() {
  return {};
}

// export default mswOrdersPage;
